module.exports = __webpack_public_path__ + "static/media/Didier_Cowling.1d6fc8f3.jpg";